import {useTranslation} from "next-i18next";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Accordion} from "../generic/accordian";
import {AccordionSummary} from "../generic/accordian-summary";
import {FC} from "react";
import {styled} from "@mui/material/styles";
import {AccordionSummaryProps} from "@mui/material/AccordionSummary";


interface CardProps {
    children: string;
    titleKey: "included" | "not-included";
}


const CustomAccordionSummary = styled(AccordionSummary)<AccordionSummaryProps>(({theme}) => ({
    height: theme.spacing(6),
    "& .MuiAccordionSummary-expandIconWrapper": {
        transform: "rotate(-90deg)",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(0deg)",
    }
}))

export function Card({children, titleKey}: CardProps) {

    const {t} = useTranslation();


    return <Accordion defaultExpanded={true}>
        <CustomAccordionSummary
            expandIcon={<ExpandMoreIcon/>}
        >
            <Typography color={"primary.dark"} variant={"h6"}>{
                // @ts-ignore
                t(titleKey)}</Typography>
        </CustomAccordionSummary>
        <AccordionDetails>
            <Typography component={"span"}>
                {children}
            </Typography>
        </AccordionDetails>
    </Accordion>

}
